import React, { useState, useEffect, useRef } from 'react';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { Header } from '../../Components/Layout/Header.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';
import { Redirect } from "react-router-dom";


export default function BonusesCasinoCashback(props) {
    const [height, setHeight] = useState(null);
    const [dialogData, setDialogData] = useState(null);
    const [redirectToGameUrl, setRedirectToGameUrl] = useState(false);
    const iframeRef = useRef(null);

    useEffect(() => {
        if (props.route.location.pathname.indexOf("/game/") === -1) {
            setRedirectToGameUrl(false);
        }
    }, [props.route.location]);

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 750)

        window.addEventListener('message', receiveMessages);

        if (iframeRef.current?.contentWindow) {
            setTimeout(() => {
                iframeRef.current.contentWindow.postMessage({ type: "darkMode", darkMode: casino.utils.getCasinoTheme() === "dark"}, "*");
            }, 1000);
        }

        return () => window.removeEventListener('message', receiveMessages);
    }, []);

    const receiveMessages = (message) => {
        if (message.data.type == "cashbackHeight") {
            setHeight(message.data.scrollHeight + "px");
        }

        if (message.data.type == "dialog") {
            let gameCode = message.data.params.sifra;
            let game = casino.casinoConstants.games.filter((game) => game.s == gameCode)[0];
            let brandName = casino.casinoConstants.brands[game.bID].nameNormalizirano;

            setDialogData({ game, brandName });
            setRedirectToGameUrl(true);
        }
    };

    return (
        <>
            {redirectToGameUrl && <Redirect to={`cashback/game/${dialogData.brandName}/${casino.utils.normalizeString(dialogData.game.n)}`} />}
            <MetaTags
                title='Promocije - SuperSport CASINO'
                description='Casino Cashback u SuperSport CASINU!'
            />
            <Header {...props} />
            <div className='cashback-container'>
                <iframe
                    ref={iframeRef}
                    title='Casino Cashback'
                    src={`${casino.config.casinoModulesUrl}cashback`}
                    scrolling='no'
                    height={height}
                />
            </div>
            <GameDetails igre={casino.casinoConstants.games} {...props} routePrefix={"/promotions/cashback"}></GameDetails>
            <ObavijestiCasino {...props} />
        </>
    )
}
